import React from 'react';
import { FormattedDate } from 'react-intl';
import translations from '@nike/gameday-translations/web';

import { Currency } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { ORDERTYPE_STRING_MAP } from '../constants';
import { deptLanguageTranslations, getUserRole } from '../../util/languageTranslations';
import { STATUS_CANCELLED } from '../orderReturns/constants';

import ToolTip from '../../components/ToolTip';

export default [
  {
    header: <TranslatedCopy id='global.orderNumber' />,
    id: 'sapOrderNumber',
    cell: order => <p className='body-3 u-bold'>{order.sapOrderNumber || order.orderNumber}</p>
  },
  {
    header: <TranslatedCopy id='global.department' />,
    id: 'departmentName',
    cell: order => {
      const { en } = translations;
      return getUserRole() && en[`shop.deptSelect.deptName.${order.departmentNumber}`] ? (
        <span>
          {order.departmentName}
          <br />
          {deptLanguageTranslations(order.departmentName, order.departmentNumber)}
        </span>
      ) : (
        <span>{order.departmentName}</span>
      );
    }
  },
  {
    header: <TranslatedCopy id='global.orderType' />,
    id: 'orderType',
    cell: order => <span>{ORDERTYPE_STRING_MAP[order.orderType]}</span>
  },
  {
    header: <TranslatedCopy id='orderstatus.poNumber' />,
    id: 'purchaseOrderRef'
  },
  {
    header: <TranslatedCopy id='global.paymentMethod' />,
    id: 'purchaseMethod'
  },
  {
    header: <TranslatedCopy id='global.numberOfUnits' />,
    id: 'orderUnitCount'
  },
  {
    header: <TranslatedCopy id='orderstatus.netTotal' />,
    id: 'orderNeTotal',
    cell: order => (
      <>
        <Currency value={order.orderNeTotal || '0'} type={order.currencyCode} />
      </>
    )
  },
  {
    header: (
      <ToolTip position='bottom' title={<TranslatedCopy id='orderstatus.customerRequestDate.ToolTip' />}>
        <TranslatedCopy id='global.crd' />
      </ToolTip>
    ),
    id: 'customerRequestDate',
    cell: order => <FormattedDate value={order.customerRequestDate} timeZone='utc' />
  },
  {
    header: <TranslatedCopy id='global.submittedBy' />,
    id: 'orderSubmittedbyFullname'
  },
  {
    header: <TranslatedCopy id='orderstatus.orderSubmittedDate' />,
    id: 'orderSubmitted',
    cell: order => <FormattedDate value={order.createTimestamp} timeZone='utc' />
  },
  {
    header: <TranslatedCopy id='orderstatus.orderStatus' />,
    id: 'orderStatus',
    cell: order => (
      <span className={order.orderStatus.toLowerCase() === STATUS_CANCELLED.toLowerCase() ? 'text-color-error' : ''}>
        {order.orderStatus}
      </span>
    )
  }
];
